/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromptsListResponse } from '../../models/prompts-list-response';

export interface PromptsPromoGet$Params {}

export function promptsPromoGet(
  http: HttpClient,
  rootUrl: string,
  params?: PromptsPromoGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PromptsListResponse>> {
  const rb = new RequestBuilder(rootUrl, promptsPromoGet.PATH, 'get');
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PromptsListResponse>;
      }),
    );
}

promptsPromoGet.PATH = '/prompts/promo';
